import type { RequestFieldKey } from '../../user-input';
import { requestFieldKeySchema } from '../../user-input';
import type { SchemaOf } from '../../helpers';
import { Joi, makeAllRequired, objectSchemaOf } from '../../helpers';

export interface IInputOption {
  label: string;
  question: string;
  message?: string;
  fieldName: string;
}

export const inputOptionSchema = objectSchemaOf<IInputOption>({
  label: Joi.string().required(),
  question: Joi.string().required(),
  message: Joi.string(),
  fieldName: Joi.string().required(),
});

export type InputOptionList = Record<RequestFieldKey, IInputOption>;

export interface IConfig {
  onInputThankyouMessages: string[];
  inputOptions: InputOptionList;
}

export const schemaMap: SchemaOf<IConfig> = {
  onInputThankyouMessages: Joi.array().items(Joi.string().required()),
  inputOptions: Joi.object().pattern(requestFieldKeySchema, inputOptionSchema),
};

export const schemaMapDefault = makeAllRequired(schemaMap);

export const defaultConfig: IConfig = {
  onInputThankyouMessages: [
    'Thanks for that.',
    'Great. Thanks!',
    'Ok. I got that.',
    'Okay.',
    'Thank you.',
  ],
  inputOptions: {
    visitorName: {
      fieldName: 'Visitor name',
      label: 'Your name',
      question: 'What is your name?',
      message: 'Can you please type in your name for me?',
    },
    staffName: {
      fieldName: 'Staff name',
      label: 'Staff name',
      question: 'Who are you here to meet?',
      message:
        'Can you please type in the name of the person you are visiting?',
    },
    deliveryWho: {
      fieldName: 'Delivery recipient',
      label: 'Recipient name',
      question: 'The package is for:',
      message: 'Can you please type in the name of the recipient?',
    },
    password: {
      fieldName: 'Password',
      label: 'Password',
      question: 'Please enter the password:',
      message: 'Can you please enter the password?',
    },
    companyName: {
      fieldName: 'Company name',
      label: 'Company name',
      question: 'Please enter the company name:',
      message: 'Can you please type the name of the company?',
    },
  },
};
